(function () {
    "use strict";

    // @ngInject
    function TopNavControllerCtor(
        $injector, $scope, AppStates, Enums, $translate, $timeout, ModalService, WorkspaceService, FeaturesService,
        EventService, UsersManager, AbTestService, hotkeys, AnalyticsService, OnboardingService,
        CompaniesManager, SetupGuideService, UiPersistenceService, _, $, moment, HomeService, PretrialersService, UserService, DeviceService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'TopNavController';

        this.AppStates = AppStates;
        this.EventService = EventService;
        this.UsersManager = UsersManager;
        this.AbTestService = AbTestService;
        this.Enums = Enums;
        this.$translate = $translate;
        this.OnboardingService = OnboardingService;
        this.$timeout = $timeout;
        this.AnalyticsService = AnalyticsService;
        this.CompaniesManager = CompaniesManager;
        this.ModalService = ModalService;
        this.WorkspaceService = WorkspaceService;
        this.SetupGuideService = SetupGuideService;
        this.UiPersistenceService = UiPersistenceService;
        this._ = _;
        this.moment = moment;
        this.showCreateMenu = false;
        this.$ = $;
        this.HomeService = HomeService;
        this.FeaturesService = FeaturesService;
        this.PretrialersService = PretrialersService;
        this.UserService = UserService;
	    this.DeviceService = DeviceService;

        this.hideCommunityForAtws = this.PretrialersService.hideCommunityForAtws();
        this.shouldShowCleanAtwsUI = this.PretrialersService.shouldShowCleanAtwsUI();
        this.showClientAccessibility = this.UserService.shouldShowClientAccessibilityTopNav(this.user);

        this.showToolsHome = this.shouldShowCleanAtwsUI;

        // load user
        this.user = this.UsersManager.getCurrUser();
        this.company = this.CompaniesManager.getCurrCompany();

        // nav bar actions
        this.navBarActions = {
            showSearch: true,
            showRightSetupGuide: false,
            showLeftSetupGuide: false
        };

        this.SetupGuideService.on(this.SetupGuideService.STEP_COMPLETED_EVENT_NAME, function (step) {
            this.setupNavBarActions();
        }.bind(this));

        this.interactiveOrStreamlinedSetupGuide = this.OnboardingService.getOnboardingFlow();

        if (this.user.isVendor()) {
            hotkeys.bindTo($scope).add({
                order: 2,
                combo: 'shift+n',
                description: 'Create Project',
                callback: function addProjectHotkeyCallback() {
                    AnalyticsService.track(this, AnalyticsService.analytics_events.hotkey_used, {
                        combo: 'shift+n',
                        action: 'create project'
                    });
                    this.createEvent();
                }.bind(this)
            });

            this.showCreateMenu = this.isShowCreateMenu();
        }

        this.updateTopNavForPretrialers();
        UsersManager.on(this.Enums.PubSubTriggers.startedTrial, function startedTrial() {
            this.homeIsEnabled = this.HomeService.shouldShowHome();
            this.updateTopNavForPretrialers();
        }.bind(this));

        UsersManager.on(this.Enums.PubSubTriggers.extendedTrial, function extendedTrial() {
            this.showCreateMenu = this.isShowCreateMenu();
        }.bind(this));

        CompaniesManager.on(this.Enums.PubSubTriggers.companySubscribed, function companySubscribed() {
            this.updateTopNavForPretrialers();
            this.setupNavBarActions();
            this.SetupGuideService.calcCompletionPercentage();

        }.bind(this));

        this.setupNavBarActions();

        OnboardingService.on('OnboardingStateRefreshed', function onOnboardingStatusChanged() {
            this.setupNavBarActions();
        }.bind(this));

        SetupGuideService.on('SetupGuideStepsUpdated', function onStepsUpdated() {
            this.setupNavBarActions();
        }.bind(this));

        OnboardingService.on('onboardingAdded', function onOnboardingStarted() {
            this.setupNavBarActions();
            this.interactiveOrStreamlinedSetupGuide = this.user.getExistingAbTestVariation(this.Enums.ABTests.interactiveOnboarding);
        }.bind(this));

        // Home
        this.homeIsEnabled = this.HomeService.shouldShowHome();

    }

    Controllers.TopNavController = Class(Controllers.BaseController, {

        constructor: TopNavControllerCtor,

        isShowCreateMenu: function isShowCreateMenu() {
            return this.user.isInTrial() || this.user.companyHasSubscription();
        },

        updateTopNavForPretrialers: function updateTopNavForPretrialers() {
            var shouldStartTrial = this.user.shouldStartTrial();
            this.upgradeText = '';
            this.communityPreTrialer = false;
            this.showProjects = true;
            this.toolsText =' MAIN_NAV._TOOLS_';
            this.showToolsHome = this.PretrialersService.shouldShowCleanAtwsUI();
            this.shouldShowCleanAtwsUI = this.showToolsHome;
            this.showClientAccessibility = this.UserService.shouldShowClientAccessibilityTopNav(this.user);

            if (shouldStartTrial) {
                if (this.user.isNetworkPretrialer()) {
                    this.upgradeText = "MAIN_NAV.NETWORK._FREE_";

                    this.updateTopNavForCommunityPretrialer();

                } else if (this.user.isProductPretrialer()) {
                    this.upgradeText = "MAIN_NAV.PRODUCT._FREE_";
                } else {
                    this.upgradeText = "MAIN_NAV.PRODUCT._FREE_";
                }
            }
        },

        updateTopNavForCommunityPretrialer: function updateTopNavForCommunityPretrialer() {
            this.showToolsHome = true;
            this.showProjects = false;
            this.toolsText =' MAIN_NAV._TOOLS_HOME_';

            //if user has workpaces, show the projects link!
            if (this.user.workspaces_count && this.user.workspaces_count > 0){
                this.showProjects = true;
            }
        },

        gotoProjects: function gotoProjects($event) {
            $event.preventDefault();
            if (this.communityPreTrialer === true && this.user.shouldStartTrial()) {
                this.$timeout(function() {
                    this.OnboardingService.openInProductIntakeForm(this.Enums.IntakeFormSource.pipeline);
                }.bind(this), 1200); // delay
            }
            if (this.shouldShowCleanAtwsUI) {
                this.PretrialersService.gotoLastWorkspace();
            } else {
                var showPipelineOnboarding = this.OnboardingService.shouldShowPipelineOnboarding();
                this.goToState(this.AppStates.root_core_navigation_pipeline, {showFeatureOnboarding: showPipelineOnboarding});
            }
        },

        onNewClick: function onNewClick() {
            if (!this.showCreateMenu) {
                this.AnalyticsService.trackClick(this, 'create project', {source: 'new button'});
                this.createEvent();
            }
        },

        createEvent: function createEvent() {
            if (this.shouldShowCleanAtwsUI){
                this.goToState(this.AppStates.root_core_navigation_business_tools);
            }else{
                this.EventService.createEventCommand();
            }
        },

        onHbLogoClick: function onHbLogoClick() {
            if (this.showToolsHome) {
                this.$state.go(this.AppStates.root_core_navigation_business_tools);
            }
            else {
                this.$state.go(this.OnboardingService.getOnboardingHomeState());
            }
        },

        setupGuideEnabledOnSmallScreens: function setupGuideEnabledOnSmallScreens() {
            this.isCompanySubscribed = this.user.companyHasSubscription();
            this.isTrialExpired = this.OnboardingService.isTrialExpired();
            this.isPreTrialer = this.user.shouldStartTrial();
            return !this.isCompanySubscribed && !this.isPreTrialer;
        },

        shouldShowSearchBar: function shouldShowSearchBar() {
            const userIsNotPreTrialer = !this.user.shouldStartTrial();
            const setupGuideIsNotActive = !this.SetupGuideService.isSetupGuideActiveForTrialers();
            const isUserSubscribed = this.OnboardingService.isUserSubscribed();

            return (
                userIsNotPreTrialer
                && (setupGuideIsNotActive || isUserSubscribed)
            )
        },

        setupNavBarActions: function setupNavBarActions() {
            this.isCompanySubscribed = this.OnboardingService.isUserSubscribed();
            this.isTrialExpired = this.OnboardingService.isTrialExpired();
            this.isPreTrialer = this.user.shouldStartTrial();

            this.navBarActions = {
                showSearch: this.shouldShowSearchBar(),
                showRightSetupGuide: this.SetupGuideService.isSetupGuideActiveForSubscribedUsers(),
                showLeftSetupGuide: !this.user.shouldStartTrial() && this.SetupGuideService.isSetupGuideActiveForTrialers()
            };
        },

        getCurrState: function getCurrState() {
            return this.$state.current.name;
        },

        isProjectBtnActive: function isProjectBtnActive() {
            return (this.getCurrState() == 'root.core.navigation.pipeline') || (this.shouldShowCleanAtwsUI && this.getCurrState() == 'root.core.navigation.event_wrapper.event.workspace.feed')
        },

        showBlinkingDot: function showBlinkingDot() {
            // This is currently not in use and its a remain of multi brand education. 
            // But its a blue blinking dot ability that can be used
            return false;
        },

        shouldShowCoronaDashboard: function shouldShowCoronaDashboard() {
            return this.user.isFeatureActive(this.FeaturesService.rolloutFeatures.coronaDashboard);
        },

        shouldShowSetupRadialProgressBar: function shouldShowSetupRadialProgressBar() {
            var showRightSetupGuide = this.navBarActions.showRightSetupGuide;
            var isStreamlinedHome = this.interactiveOrStreamlinedSetupGuide === 'streamlined_home';

            var trialIsLessThan90DaysOld = false;
            if (
                this.user
                && this.user.account
                && this.user.account.trial
                && this.user.account.trial.start_date
            ) {
                var trialStartDate = this.user.account.trial.start_date;
                var ninetyDaysAgo = this.moment().add(-90, 'days');
                trialIsLessThan90DaysOld = this.moment(ninetyDaysAgo).isBefore(trialStartDate);
            }

            return showRightSetupGuide && isStreamlinedHome && trialIsLessThan90DaysOld;
        }
    });
}());
